import {Button, Col, Row} from "antd";
import styled from "styled-components";

export const FormContainer = styled(Row)`
    width: 100%;
    padding-right: 20px;

    @media screen and (max-width: 992px) {
        padding-top: 20px;
        padding-right: 0;
    }
`;

// Customer-specific compact form container
export const CustomerFormContainer = styled(Row)`
    width: 100%;
    padding-right: 15px;

    @media screen and (max-width: 992px) {
        padding-top: 10px;
        padding-right: 0;
    }
`;

export const FormHeader = styled(Col)`
    font-size: 20px;
    font-weight: bold;
    width: 100%;
    border-bottom: 1px solid #c6c5c5;
    padding-bottom: 5px;
`;

// Customer-specific compact header
export const CustomerFormHeader = styled(Col)`
    font-size: 18px;
    font-weight: bold;
    width: 100%;
    border-bottom: 1px solid #c6c5c5;
    padding-bottom: 3px;
    margin-bottom: 10px;
`;

export const SubmitDeliveryButton = styled(Button)`
    width: 100%;
    background-color: #b2fc35;
    color: black;
    font-weight: bold;
    border: 1px solid black;
    &:hover {
        background-color: #d5fd91;
        color: black;
        border: 1px solid black;
    }
    &:focus,
    &:active {
        background-color: #d5fd91;
        color: black;
        border: 1px solid black;
    }
`;

// Customer-specific compact submit button
export const CustomerSubmitDeliveryButton = styled(Button)`
    width: 40%;
    min-width: 200px;
    background-color: #b2fc35;
    color: black;
    font-weight: bold;
    border: 1px solid black;
    margin-top: 10px;
    height: 36px;

    &:hover {
        background-color: #d5fd91;
        color: black;
        border: 1px solid black;
    }
    &:focus,
    &:active {
        background-color: #d5fd91;
        color: black;
        border: 1px solid black;
    }
`;

// Customer-specific button container for inline layout
export const CustomerButtonContainer = styled.div`
    display: flex;
    width: 100%;
    margin-top: 10px;
    justify-content: space-between;
    align-items: flex-end;

    @media screen and (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
`;

export const CustomerOrderInformationRow = styled(Row)`
    display: flex;
    width: 100% !important;
    align-items: flex-start;

    @media screen and (max-width: 768px) {
        flex-direction: column !important;
        align-items: flex-start;
        gap: 10px;
    }
`;

export const CustomerOrderInformationCol = styled(Col)`
    display: flex;
    flex-direction: column;
    max-width: 50% !important;
    gap: 16px !important;

    @media screen and (max-width: 768px) {
        width: 100% !important;
        flex-direction: column !important;
        align-items: flex-start;
        gap: 10px;
    }

    /* Form item alignment fix */
    .ant-form-item {
        margin-bottom: 0 !important;
    }

    .ant-form-item-explain {
        margin-top: 4px;
        min-height: 22px;
    }
`;

// DeliveryRequestForm için özel tab stilleri
export const DeliveryRequestTabs = styled.div`
    width: 100%;
    .delivery-request-tabs {
        .ant-tabs-nav {
            margin-bottom: 16px !important;
        }

        .ant-tabs-tab {
            padding: 10px 24px !important;
            font-size: 16px !important;
            min-height: 48px !important;
            min-width: 150px !important;
            text-align: center !important;
            margin-right: 12px !important;
            border-radius: 8px !important;
            background-color: #f5f5f5 !important;
            border: 1px solid #d9d9d9 !important;
            transition: all 0.2s ease !important;
        }

        .ant-tabs-tab:hover {
            background-color: #e6f7ff !important;
            border-color: #40a9ff !important;
        }

        .ant-tabs-tab-active {
            background-color: #b2fc35 !important;
            border-color: #b2fc35 !important;
            box-shadow: 0 2px 4px rgba(178, 252, 53, 0.3) !important;
        }

        .ant-tabs-tab-btn {
            color: #666 !important;
            font-weight: 500 !important;
            width: 100% !important;
            text-align: center !important;
            line-height: 24px !important;
            font-size: 16px !important;
            padding: 10px 24px !important;
        }

        .ant-tabs-tab-active .ant-tabs-tab-btn {
            color: #000 !important;
            font-weight: 600 !important;
        }

        .ant-tabs-ink-bar {
            display: none !important;
        }
    }
`;
